import { HTMLTextAreaCombinedProps } from './types';

const usePresenter = (props: HTMLTextAreaCombinedProps): HTMLTextAreaCombinedProps => {
  props = {
    ...props,
    textArea: {
      ...props.textArea,
      resizeToContent: true,
    },
  };

  return props;
};

export default usePresenter;
